import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import React from 'react'

import { useContext } from './Context'
import { dateTimeZoneOptions } from '../../dateTimeZoneOptions'
import { NumberInput, Select } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'

const unitOptions = [
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
]

export const DynamicValue = () => {
  const { options, onChange, newValue, valueType } = useContext()
  const [dynamicSelect, setDynamicSelect] = React.useState('')
  const [dynamicNumber, setDynamicNumber] = React.useState('')
  const [dynamicUnit, setDynamicUnit] = React.useState('days')

  const [selectValue, setSelectValue] = React.useState()
  const [unitSelectValue, setUnitSelectValue] = React.useState()

  React.useEffect(() => {
    if (!isEmpty(dynamicSelect)) {
      let value = ''
      if (!isEmpty(dynamicSelect)) {
        value = dynamicSelect
      }
      if (!isEmpty(dynamicNumber)) {
        value = `${dynamicSelect} ${dynamicNumber}`
        if (!isEmpty(dynamicUnit)) {
          value = `${dynamicSelect} ${dynamicNumber} ${dynamicUnit}`
        }
      }

      // const dynamicValue = `<<${dynamicSelect} ${dynamicNumber} ${dynamicUnit}>>`
      value = `<<${value}>>`

      onChange(value)
    }
    // onChange intentionally excluded: it is a plain function redefined every render of the Context
    // provider (not memoized), and it calls the caller's setValue — which re-renders that provider and
    // hands this effect a new onChange again. Tracking it here would loop. Only the dynamicSelect/
    // dynamicNumber/dynamicUnit inputs the user actually edits should re-trigger this.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicSelect, dynamicNumber, dynamicUnit])

  React.useEffect(() => {
    if (isEmpty(selectValue))
      if (valueType === 'dynamic') {
        let initialValue = newValue
        initialValue = initialValue?.substring?.(2, newValue.length - 2)
        initialValue = initialValue?.split?.(' ')

        const select = find(dateTimeZoneOptions, (item) => {
          return item?.value === initialValue?.[0]
        })

        const unit = find(unitOptions, (item) => {
          return item?.value === initialValue?.[2]
        })

        setSelectValue(select as any)
        setUnitSelectValue(unit as any)
        setDynamicSelect(initialValue?.[0] ?? '')
        setDynamicNumber(initialValue?.[1] ?? '')
        setDynamicUnit(initialValue?.[2] ?? '')
      }
  }, [valueType, newValue, selectValue])

  return (
    <HorizontalStack gap={1}>
      <div>
        <Select
          value={selectValue}
          options={options}
          onChange={(e: any) => {
            setSelectValue(e)
            setDynamicSelect(e?.value)
          }}
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          placeholder={'Value'}
        />
      </div>
      <div className={'ml-3'} style={{ width: '100px' }}>
        <NumberInput
          value={dynamicNumber}
          disabled={isEmpty(selectValue)}
          onChange={(e) => {
            const value = e?.target?.value
            setDynamicNumber(value)
          }}
          placeholder={'Offset'}
        />
      </div>
      <div className={'ml-3'} style={{ width: '150px' }}>
        <Select
          options={unitOptions}
          value={unitSelectValue}
          onChange={(e: any) => {
            setUnitSelectValue(e)
            setDynamicUnit(e?.value)
          }}
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          placeholder={'Unit'}
        />
      </div>
    </HorizontalStack>
  )
}
